const RESOURCE_FEED_INFO_BLOCK = '.wp-block-ssm-resource-feed';
const RESOURCE_FEED_ITEM = '.wp-block-ssm-resource-feed__item';
const RESOURCE_FEED_DESCRIPTION = '.wp-block-ssm-resource-feed__description';

const READ_MORE_BUTTON = '.read-more';

const TEXT_LIMIT = 140;

export const ResourceFeed = () => {
    document.querySelectorAll(RESOURCE_FEED_INFO_BLOCK).forEach((block) => {
        const items = block.querySelectorAll(RESOURCE_FEED_ITEM);

        if (!items?.length) return;

        items.forEach((item) => {
            const content = item.querySelector(RESOURCE_FEED_DESCRIPTION);
            if (!content) return;

            const modalLink = content.querySelector(READ_MORE_BUTTON);

            const cloned = content.cloneNode(true);
            cloned.querySelectorAll('a').forEach((a) => a.remove());
            const fullText = cloned.textContent.trim();

            if (fullText.length <= TEXT_LIMIT) {
                modalLink?.remove();

                return;
            }

            const shortText = fullText.slice(0, TEXT_LIMIT) + '...';

            content.innerHTML = '';
            content.append(shortText + ' ');

            if (modalLink) {
                modalLink.classList.remove('hidden');
                content.appendChild(modalLink);
            }
        });
    });
};
